<template>
    <div class="wrapper">
        <!-- header -->
        <div class="header">
            <div class="row no-gutters">
                <div class="col-auto">
                    <a href="" class="btn btn-link text-dark"><i class="material-icons">chevron_left</i></a>
                </div>
                <div class="col text-center"></div>
                <div class="col-auto">
                </div>
            </div>
        </div>
        <!-- header ends -->

        <b-container class="h-100">
            <b-row class="text-center" no-gutters align-h="center" align-v="center">
                <b-col align-self="center">
                    <h1 class="display-3 my-4">¡Uuups! Error 404</h1>
                    <p class="my-4">La sección que estas buscando no existe.</p>
                    <b-button @click="goBack" variant="outline-default" class="px-6 my-4 align-middle"
                              size="lg"><i class="material-icons">replay</i> Regresar</b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>

</template>

<script>
export default {
    name: 'Error404',
    mounted() {
      this.$emit('loader');
    },
    methods: {
        goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
        }
    }
}
</script>
